import { z } from "zod";
import { PLAN_IDS, type PlanId } from "./subscription.js";

export const ORDER_STATUSES = ["pending", "paid", "expired", "failed", "mismatch"] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

/** อายุ QR (นาที) ตาม design */
export const QR_TTL_MINUTES = 15;

/** ราคาขั้นต่ำของแพ็กเกจเสียเงิน (บาท): Opn PromptPay รับ charge ตั้งแต่ 20 บาทขึ้นไป */
export const MIN_PAID_PRICE_THB = 20;

/** แปลงบาทเป็นสตางค์ (หน่วยที่ Opn ใช้) แบบกัน floating point */
export const toSatang = (thb: number): number => Math.round((thb + Number.EPSILON) * 100);

/** POST /orders  ผู้ซื้อระบุแพ็กเกจเท่านั้น ราคาอ่านจากตาราง plans ฝั่ง server */
export const createOrderRequestSchema = z.object({ plan: z.enum(PLAN_IDS).refine((p) => p !== "free", "free_not_purchasable") });

export interface OrderDto {
  orderId: string;
  plan: PlanId;
  amount_thb: number;
  status: OrderStatus;
  /** QR PromptPay (ภาพ) จาก provider */
  qr?: { imageUrl: string };
  expiresAt: string;
  paidAt?: string;
  /** เมื่อ paid: ผลต่อ subscription */
  activated?: { kind: "new" | "renew" | "upgrade"; periodEnd: string };
  receiptNo?: string;
  mismatch?: { expected_thb: number; received_thb: number };
}

export interface PlanDto {
  plan: PlanId;
  price_thb: number;
  estimates_per_month: number;
  saved_jobs_limit: number | null;
  quotation: boolean;
  gate_per_day: number;
}
